import { Drawer, Modal } from 'antd';
import React, { FC, PropsWithChildren, useEffect, useState } from 'react';

import { useWindowDimensions } from '@/hooks';

import { ModalTitleActions } from '../ModalTitleActions';
import styles from './styles.module.scss';

interface Props {
  CustomHeader?: React.FC<any>;
  desktopModal?: boolean;
  footer?: React.ReactNode;
  handleClose: () => void;
  handleSave?: () => void;
  height?: string | number;
  mobileDimension?: number;
  mobileTitle?: string;
  modalClassName?: string;
  open: boolean;
  scrollActive?: boolean;
  title: string;
}

export const DrawerWrapper: FC<PropsWithChildren<Props>> = ({
  children,
  desktopModal,
  footer,
  handleClose,
  handleSave,
  mobileDimension,
  mobileTitle,
  modalClassName,
  open,
  scrollActive,
  title,
  ...props
}) => {
  const windowDimensions = useWindowDimensions();
  const windowWidth = windowDimensions.width;
  const windowHeight = windowDimensions.height;
  const [isMobile, setIsMobile] = useState(windowWidth < mobileDimension);

  useEffect(() => {
    setIsMobile(windowWidth < mobileDimension);
  }, [windowWidth]);

  useEffect(() => {
    if (isMobile || desktopModal) {
      const scrollWidth =
        document.documentElement.style.getPropertyValue('--scrollbar-width-default') || 0;

      document.documentElement.style.setProperty('--scrollbar-width', `${scrollWidth}`);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.documentElement.style.removeProperty('--scrollbar-width');
      document.body.style.overflow = '';
    };
  }, []);

  if (!isMobile) {
    if (desktopModal) {
      return (
        <Modal
          title={
            <div className={styles.header}>
              <span className={styles.modalTitle}>{title}</span>
              <ModalTitleActions onClose={handleClose} onSave={handleSave} />
            </div>
          }
          open
          onClose={handleClose}
          onCancel={handleClose}
          width="auto"
          footer={footer}
          destroyOnClose
          closable={false}
          className={modalClassName}
          wrapClassName={styles.wrapClassName}
        >
          {children}
        </Modal>
      );
    }

    return <>{children}</>;
  }

  return (
    <Drawer
      title={null}
      closable={false}
      placement="bottom"
      onClose={handleClose}
      open={open}
      className={styles.drawer}
      height="100%"
      rootClassName={styles.root}
      footer={footer}
      {...props}
    >
      <div className={styles.header}>
        <div className={styles.title}>{mobileTitle || title}</div>
        <ModalTitleActions onClose={handleClose} onSave={handleSave} />
      </div>
      <div className={styles.content}>{children}</div>
    </Drawer>
  );
};
